<template>
  <md-card>
    <md-card-content>
      <div class="md-layout">
        <h4>Condition</h4>
        <div
          class="md-layout-item md-size-100 occupancy"
          style="display: flex;
                        justify-content: space-between;
                        align-items: center;
                        flex-wrap: wrap;
                    "
        >
          <span class="title">Hotel occupancy</span>
          <ValidationProvider name="Hotel occupancy" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
            <div class="occupancy">
              <md-radio v-model="condition.total_hotel_occupancy_format" value="PERCENTAGE">% occ</md-radio>
              <md-radio v-model="condition.total_hotel_occupancy_format" value="ABSOLUTE">rooms</md-radio>
              <md-radio v-model="condition.total_hotel_occupancy_format" value="RELATIVE">free rooms</md-radio>
              <span class="radio-error" :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <span>between</span>
          <ValidationProvider name="min" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
            <md-field
              style="display: inline-flex"
              class="md-field md-layout-item md-size-20 md-theme-default"
              :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]"
            >
              <label>min</label>
              <md-input type="number" v-model="condition.total_hotel_occupancy_sold_from" />
              <span class="radio-error" :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
            </md-field>
          </ValidationProvider>
          <span>and</span>
          <ValidationProvider name="max" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
            <md-field
              style="display: inline-flex"
              class="md-field md-layout-item md-size-20 md-theme-default"
              :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]"
            >
              <label>max</label>
              <md-input type="number" v-model="condition.total_hotel_occupancy_sold_to" />
              <span class="radio-error" :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
            </md-field>
          </ValidationProvider>
        </div>
        <div
          v-if="showRoomOccupancy"
          class="md-layout-item md-size-100"
          style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        flex-wrap: wrap;
                    "
        >
          <span class="title">Room occupancy</span>
          <ValidationProvider name="Room occupancy" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
            <div class="occupancy">
              <md-radio v-model="condition.total_room_occupancy_format" value="PERCENTAGE">% occ</md-radio>
              <md-radio v-model="condition.total_room_occupancy_format" value="ABSOLUTE">rooms</md-radio>
              <md-radio v-model="condition.total_room_occupancy_format" value="RELATIVE">free rooms</md-radio>
              <span class="radio-error" :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <span>between</span>
          <ValidationProvider name="min" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
            <md-field
              style="display: inline-flex"
              class="md-field md-layout-item md-size-20 md-theme-default"
              :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]"
            >
              <label>min</label>
              <md-input type="number" v-model="condition.total_room_occupancy_sold_from" />
              <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
            </md-field>
          </ValidationProvider>
          <span>and</span>
          <ValidationProvider name="max" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
            <md-field
              style="display: inline-flex"
              class="md-field md-layout-item md-size-20 md-theme-default"
              :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]"
            >
              <label>max</label>
              <md-input type="number" v-model="condition.total_room_occupancy_sold_to" />
              <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50">
          <md-checkbox v-model="condition.online">No include guarantee</md-checkbox>
        </div>
      </div>
      <h4>Actions</h4>

      <allotment-rule-actions :action="condition.actions[0]" :button="false"> </allotment-rule-actions>
      <h4>Apply to</h4>
      <div
        class="md-layout-item"
        style="display: flex;
                                          flex-wrap: wrap;
                                          align-items: center;
                                          justify-content: space-between;"
      >
        <pax-combination-select
          class="md-layout-item md-size-50"
          multiple
          v-model="condition.actions[0].apply_to_dto.pax_combination_codes"
        ></pax-combination-select>

        <div class="md-layout-item md-size-50 vertical-middle">
          In
          <md-checkbox
            v-model="condition.actions[0].apply_to_dto.channels_online"
            class="text-nowrap"
            style="margin-left: 1em;"
            @change="resetChannelIds"
          >
            online
          </md-checkbox>
          channels
          <channel-select
            style="margin-left: 1em;"
            :online="condition.actions[0].apply_to_dto.channels_online"
            v-model="condition.actions[0].apply_to_dto.channel_ids"
            multiple
          ></channel-select>
        </div>
        <board-select
          required
          multiple
          class="md-layout-item md-size-50"
          v-model="condition.actions[0].apply_to_dto.board_ids"
        ></board-select>
        <rate-select multiple class="md-layout-item md-size-50" v-model="condition.actions[0].apply_to_dto.rate_ids"></rate-select>
      </div>

      <md-button class="md-icon-button md-white" @click="$emit('delete')">
        <md-icon>delete</md-icon>
      </md-button>
    </md-card-content>
  </md-card>
</template>

<script>
import Vue from 'vue'
import AllotmentRuleActions from './AllotmentRuleActions.vue'
import PaxCombinationSelect from '../Inputs/PaxCombinationSelect.vue'
import BoardSelect from '../Inputs/BoardSelect.vue'
import ChannelSelect from '../Inputs/ChannelSelect.vue'
import RateSelect from '../Inputs/RateSelect.vue'
import { Action } from './models'

export default {
  name: 'AllotmentRuleCard',
  data() {
    return {
      roomTypeSelect: [],
    }
  },
  props: {
    condition: Object,
    room_type_ids: Array,
  },
  components: {
    PaxCombinationSelect,
    AllotmentRuleActions,
    ChannelSelect,
    RateSelect,
    BoardSelect,
  },
  methods: {
    addActionTo() {
      this.condition.actions.push(new Action())
    },
    resetChannelIds() {
      this.condition.actions[0].apply_to_dto.channel_ids = []
    },
  },
  computed: {
    showRoomOccupancy: function() {
      return !!this.room_type_ids && this.room_type_ids.length > 0 && this.room_type_ids.length < this.roomTypeSelect.length
    },
  },
  created() {
    if (!this.condition.actions) {
      Vue.set(this.condition, 'actions', [new Action()])
      Vue.set(this.condition.actions[0], 'allotment_value_format', 'STOP_SALES')
    }

    this.roomTypeSelect = this.$store.getters.get('RoomTypeSelect')

    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'set' && mutation.payload.name === 'RoomTypeSelect') {
        this.roomTypeSelect = mutation.payload.value
      }
    })
  },
  beforeDestroy() {
    this.unsubscribe()
  },
}
</script>

<style lang="scss">
.occupancy {
  .title {
    width: 110px;
  }
}

.occupancy {
  position: relative;
  display: inline-flex;

  .radio-error {
    height: 20px;
    position: absolute;
    bottom: -22px;
    color: #ff1744;
    font-size: 12px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
}
</style>
